import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AnexosSelectionService {
  // Mapa: idTarea (string) -> Set de ids de anexos
  private map: Map<string, Set<number>> = new Map();

  exists(idTarea: string | null | undefined): boolean {
    const key = idTarea?.toString() ?? 'null';
    return this.map.has(key);
  }

  get(idTarea: string | null | undefined): Set<number> {
    const key = idTarea?.toString() ?? 'null';
    let s = this.map.get(key);
    if (!s) {
      s = new Set<number>();
      this.map.set(key, s);
    }
    return s;
  }

  set(idTarea: string | null | undefined, set: Set<number>): void {
    const key = idTarea?.toString() ?? 'null';
    this.map.set(key, set);
  }

  add(idTarea: string | null | undefined, anexoId: number): void {
    this.get(idTarea).add(anexoId);
  }

  delete(idTarea: string | null | undefined, anexoId: number): void {
    this.get(idTarea).delete(anexoId);
  }

  clear(idTarea: string | null | undefined): void {
    this.map.set(idTarea?.toString() ?? 'null', new Set<number>());
  }
}
